import { store } from '@/store';
import QuestionBuilder from './QuestionBuilder';

export default class TransmissionQuestionBuilder extends QuestionBuilder {
    public constructor() {
        super(true, false);
    }

    answers() {
        return store.getters['vehicleSearchModule/transmissions'];
    }

    setAnswer(answer: string) {
        store.dispatch('vehicleModule/submitTransmission', answer);
        store.dispatch('vehicleSearchModule/updateFilteredResults');
    }
}
